// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';

// import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
 const firebaseConfig = {
  apiKey: "AIzaSyCO_E3eIgX-4Nhue10W5Sb6WmmwxhPB7d4",
  authDomain: "galaxyworldwideshipping-18a12.firebaseapp.com",
  projectId: "galaxyworldwideshipping-18a12",
  storageBucket: "galaxyworldwideshipping-18a12.appspot.com",
  messagingSenderId: "188949712933",
  appId: "1:188949712933:web:bac2456c404a83d14a6fcc",
  measurementId: "G-TR1HSHPDRF"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);